// NewCategory.js
import React, { useState ,useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import './NewCategory.css';
import { baseUrl } from '../components/constant';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; // Ensure toastify styles are imported
import Select from 'react-select';
const NewCoupon = () => {
  const [Code, setCode] = useState('');
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [Package, setPackage] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const options = []

  const navigate = useNavigate();

 
  const fetccPackges = async () => {
    setLoading(true);
    try {
      const token = JSON.parse(localStorage.getItem('token'));
      console.log("baseUrl",baseUrl)
      const response = await fetch(`https://dashboard.onyxen-regalia.com/backend/api/subscriptions`, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const data = await response.json();
        console.log("data",data)
        setPackage(data); // Adjust based on your API response structure
      } else {
        toast.error('Failed to fetch Ads');
      }
    } catch (err) {
      setError('Failed to fetch Ads');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetccPackges();
  }, []);


  const handleSave = async (e) => {
    e.preventDefault();
    setError('')
    if (!selectedOptions.value) {
      toast.error('Please choose the package');
      return;
    }

    if (!Code) {
      toast.error('Please enter coupon code');
      return;
    }
  
   
    
    setLoading(true);

    try {
      const token = JSON.parse(localStorage.getItem('token'));
      if (!token) {
        toast.error('You are not authenticated.');
        return;
      }
      const formData = new FormData();
      formData.append('code', Code);
      formData.append('subscription_id', selectedOptions.value);
      const response = await fetch(baseUrl + '/coupons', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          "Authorization": 'Bearer ' + token,
        },
        body: formData,
      });

      const data = await response.json();
      if (response.ok) {
        toast.success('added successfully');
        navigate('/Coupons');// Redirect to the home page within the root layout
      } else {
        if (data.errors) {
          if (data.errors.name) {
            toast.error(data.errors.name[0]);
          }
        }
      }
    } catch (err) {
      console.log("err", err)
      // Handle network or unexpected errors
      setError('An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };


  const formattedOptions = Package.map(option => ({
    value: option.id,
    label: `${option.name} - ${option.name_ar}`,
  }));

  const handleChange = selected => {
    setSelectedOptions(selected);
  };
console.log("selectedOptions",selectedOptions)


  const customStyles = {
    control: (base) => ({
      ...base,
      backgroundColor: "#fff",
      fontSize: 20,
      color: "#000",
      border: "1px solid #ccc",
      boxShadow: "none",
      "&:hover": {
        border: "1px solid #888",
      },
      width: "100%",
      margin: "0 auto", // Center align
    }),
    option: (base, { isFocused, isSelected }) => ({
      ...base,
      backgroundColor: isSelected
        ? "rgba(154, 57, 57, 0.8)"
        : isFocused
          ? "rgba(154, 57, 57, 0.2)"
          : "#fff",
      color: isSelected ? "#fff" : "#000",
      fontSize: 18,
      padding: 10,
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: "rgba(154, 57, 57, 0.2)",
      color: "#000",
      fontSize: 16,
      borderRadius: 5,
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: "#000",
    }),
    multiValueRemove: (base) => ({
      ...base,
      color: "#000",
      ":hover": {
        backgroundColor: "rgba(154, 57, 57, 0.8)",
        color: "#fff",
      },
    }),
  };

  return (
    <div style={{ width: '100%', justifyContent: "center" }}>
      {loading && (
        <div className="loader-overlay">
          <div className="loader"></div>
        </div>
      )}


      <h2 style={{ color: "#000", textAlign: 'center' }}>New Coupon</h2>

     


      <div className="new-category-container">
        <div className="new-category">

        <div  style={{
            width: "70%",
            color: "#000",
            display:'contents'
          }}>
            <h3>Select Package</h3>
            <Select
              options={formattedOptions}
              isMulti={false}
              onChange={handleChange}
              value={selectedOptions}
              styles={customStyles}
            />
          </div>

          <div className="new-form-group">
            <label htmlFor="name">Code</label>
            <input
              style={{ backgroundColor: "#fff", fontSize: 20, width: "80%", color: "#000" }}
              placeholder='Code'
              required
              type="text"
              id="name"
              value={Code}
              onChange={(e) => setCode(e.target.value)}
            />
          </div>

       
<div style={{height:'20px'}}></div>

        
        
          <div className="form-buttons">
            <button onClick={handleSave} style={{ backgroundColor: "rgb(154, 57, 57)" }}>Save</button>
            <button onClick={() => navigate('/Coupons')} style={{ backgroundColor: "#000" }}>Cancel</button>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default NewCoupon;
